
<section class="bg-coka-blue">
  <div class="grid lg:h-screen lg:grid-cols-3">
    <div class="flex items-center justify-center px-4 py-6 lg:py-0 sm:px-0">
      <form (submit)="onResetPassword(loginForm)" #loginForm="ngForm" class="w-4/5">
        <h1 class="text-xl font-bold  text-white">Password dimanticata? Nessun problema!</h1>
        <hr class="my-2" >
        <div>
          <label for="email" class="block mb-2 text-sm font-medium  text-gray-300">Email</label>
          <input ngModel #emailInput='ngModel'  type="email" name="email" id="email" class="border  text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white" placeholder="Inserisci la mail" required="">
        </div>
        <div class="flex items-center justify-between">
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <a [routerLink]="[ '/login']" class=" mt-2 text-sm font-medium text-coka-pink hover:underline text-primary-500">Torna al login</a>
            </div>
          </div>
        </div>
        <button type="submit" class="w-full my-3 text-white bg-coka-pink hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-primary-600 hover:bg-primary-700 focus:ring-primary-800">
          Resetta la password
        </button>
      </form>
    </div>
    <div class="z-0 flex col-span-2 items-center justify-center px-4 py-6 bg-coka-pink opacity-90 lg:py-0 sm:px-0">
      <div class="z-10 max-w-md xl:max-w-xl">
        <a href="https://cokaclub.it" class="flex items-center mb-4 text-2xl font-semibold text-white">
          CokaClub.it
        </a>
        <h1 class="mb-4 text-3xl font-extrabold leading-none tracking-tight text-white xl:text-5xl">Gestisci gli appuntamenti con un click!</h1>
        <p class="mb-4 font-bold text-coka-blue lg:mb-8">Controlla gli appuntamenti che hanno preso i tuoi clienti presso il tuo negozio, oppure segna direttamente tu gli appuntamenti dei tuoi clienti così da avere il quadro completo della situazione in ogni istante. </p>
        <div class="flex items-center divide-x divide-primary-500">
          <a href="https://blank-software.it" class="text-white">
            <span class="text-sm text-primary-200">Sviluppato da Blank Software</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>


